import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";

export default function MinecraftTorch({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  lightColor = "#ffdd88",
  lightIntensity = 3.2,
  lightDistance = 20,
  lightDecay = 1.6,
  lightOffset = [0, 0.6, 0],
  castShadows = false,
  shadowMapSize = 256,
  ...props
}) {
  const { scene } = useGLTF("/minecraft_torch.glb");
  const torchScene = useMemo(() => scene.clone(true), [scene]);
  const torchLight = useMemo(() => {
    const light = new THREE.PointLight(lightColor, lightIntensity, lightDistance, lightDecay);
    light.castShadow = castShadows;
    if (castShadows) {
      light.shadow.mapSize.set(shadowMapSize, shadowMapSize);
      light.shadow.bias = -0.001;
      light.shadow.normalBias = 0.01;
      light.shadow.autoUpdate = false;
      light.shadow.needsUpdate = true;
    } else {
      light.shadow.autoUpdate = false;
    }
    return light;
  }, [castShadows, lightColor, lightDecay, lightDistance, lightIntensity, shadowMapSize]);

  useEffect(() => {
    torchScene.traverse((child) => {
      if (child instanceof THREE.Mesh || child instanceof THREE.SkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [torchScene]);

  useEffect(() => {
    torchLight.color.set(lightColor);
    torchLight.intensity = lightIntensity;
    torchLight.distance = lightDistance;
    torchLight.decay = lightDecay;
  }, [lightColor, lightDecay, lightDistance, lightIntensity, torchLight]);

  useEffect(() => {
    torchLight.position.set(lightOffset[0], lightOffset[1], lightOffset[2]);
  }, [lightOffset, torchLight]);

  return (
    <group position={position} rotation={rotation} scale={scale} {...props}>
      <primitive object={torchScene} />
      <primitive object={torchLight} />
    </group>
  );
}

useGLTF.preload("/minecraft_torch.glb");
